import type { Strings } from '../index.ts';

/**
 * Die Warteschlange. Eine Playlist liegt auf der Instanz und ist morgen noch da, die Warteschlange
 * gehört zu diesem Browser-Tab und ist mit ihm weg. Jeder Satz sagt, um welche der beiden Listen es
 * geht, denn genau das ist der Unterschied, den man verstehen muss: steht ein `list` in der Adresse,
 * ist die Warteschlange ein Fenster auf diese Playlist, und ein Druck ändert dann die Playlist. Die
 * Liste selbst zeichnet die Seitenspalte der Videoseite, und deren Wörter stehen in `watch.queue`.
 */
export const queue: Strings['queue'] = {
  add: {
    label: (title) => `„${title}“ zur Warteschlange hinzufügen`,
    title: 'Zur Warteschlange hinzufügen',
    remove: (title) => `„${title}“ aus der Warteschlange entfernen`,
    removeTitle: 'Aus der Warteschlange entfernen',
    removed: 'Aus der Warteschlange entfernt.',
    started: 'Die Warteschlange läuft.',
    startedPaused: 'Die Warteschlange steht bereit. Zum Starten auf Wiedergabe drücken.',
    startedWithPlaying: 'Die Warteschlange enthält jetzt das laufende Video.',
    addedNext: 'Als nächstes Video hinzugefügt.',
    addedEnd: 'Ans Ende der Warteschlange hinzugefügt.',
    addedPlaylistEnd: 'Ans Ende der Playlist hinzugefügt.',
    removedPlaylist: 'Aus der Playlist entfernt.',
    addRefused: (reason) => `${reason}. Die Playlist wurde nicht geändert.`,
    removeRefused: (reason) => `${reason}. Die Playlist wurde nicht geändert.`,
    working: 'Die Playlist wird geändert…',
  },

  press: {
    now: 'Jetzt abspielen',
    nowLabel: (title) => `„${title}“ jetzt abspielen und die Warteschlange leeren`,
    nowTitle: 'Die Warteschlange wird geleert und dieses Video geöffnet.',
    next: 'Als Nächstes abspielen',
    nextLabel: (title) => `„${title}“ nach dem laufenden Video abspielen`,
    nextTitle: 'Dieses Video läuft direkt nach dem laufenden. Diese Seite bleibt offen.',
    nextUnavailable:
      'Diese Liste ist eine Playlist, und eine Playlist kann kein Video als Nächstes aufnehmen.',
    nextUnavailableLabel: (title) =>
      `„${title}“ kann nicht als Nächstes abgespielt werden, weil diese Liste eine Playlist ist.`,
  },

  ended: {
    line: 'Die Warteschlange ist zu Ende. Die Liste ist weiterhin in diesem Tab.',
    close: 'Die Warteschlange leeren',
  },
};
